import React, {useEffect, useMemo, useState} from 'react'
import CopyPastTagAdd from '../../../../Contacts/AllContactsList/Modal/CopyPastTagAdd'

import {BulkMessageCopyPast, BulkMsgDraftData} from '../../../BulkMessageSlice/BulkMessageSlice'
import {useDispatch, useSelector} from 'react-redux'
import {
  ContactClosePopup,
  ContactOpenPopup,
} from '../../../../../../Components/PopupSlice/popupSlice'
import CreatableSelect from 'react-select/creatable'
import {isMobileValidate, isNumberOnly} from '../../../../../../Utils/_helpers/ValidationSchema'
import {SelectOption} from '../../../../../../types'
import {validateArrayPhones, validateArrayPhonesRegion} from '../../../../../../Utils/_helpers'
import { useLazyGetGroupQuery } from '../../../../../../../services/cellcast'
import { getDefaultRegion } from '../../../../accounts/Overview/OverviewSlice/UserDetailsSlice'

const UploadContactByCopyPast = ({setBulkMessageData, bulkMessageData, error, setError}: any) => {
  const dispatch = useDispatch()
  const [copyPast, setCopyPast] = useState('number')
  const [customData, setCustomData] = useState('')
  const [numberPaste, setNumberPaste] = useState<SelectOption<string>[]>([])
  const [tagPopup, setTagPopup] = useState(false)
  const [isDisable, setIsDisable] = useState(true)
  const [getGroup] = useLazyGetGroupQuery()
  const userRegion = useSelector(getDefaultRegion)

  const UploadData = () => {
    const values: any = {
      uploadData: numberPaste.map((item) => item.value).join(',') || '',
      type: 'only-number',

      campaignUpload: true,
    }
    const val: any = {
      uploadData: customData,
      type: 'custom-fields',

      campaignUpload: true,
    }
    const FinalData2 = new FormData()
    const FinalData = new FormData()
    for (var key in values) {
      FinalData.append(key, values[key])
    }
    for (var key in val) {
      FinalData2.append(key, val[key])
    }

    dispatch(ContactClosePopup())
    if (copyPast === 'number') {
      dispatch(BulkMessageCopyPast(FinalData)).then((res: any) => {
        let id = res.payload.data.campaignTagId
        setBulkMessageData({
          ...bulkMessageData,
          to: {selectedType: 'copyPaste', value: [`tag_${id}`]},
        })
        dispatch(
          BulkMsgDraftData({
            ...bulkMessageData,
            scheduledAt: '',
            to: {selectedType: 'copyPaste', value: [`tag_${id}`]},
          })
        )
        dispatch(ContactOpenPopup())
        getGroup(null)
        setTagPopup(false)
      })
    } else {
      dispatch(BulkMessageCopyPast(FinalData2)).then((res: any) => {
        let id = res.payload.data.campaignTagId

        setBulkMessageData({
          ...bulkMessageData,
          to: {selectedType: 'copyPaste', value: [`tag_${id}`]},
        })
        dispatch(
          BulkMsgDraftData({
            ...bulkMessageData,
            scheduledAt: '',
            to: {selectedType: 'copyPaste', value: [`tag_${id}`]},
          })
        )

        dispatch(ContactOpenPopup())
        getGroup(null)
        setTagPopup(false)
      })
    }
    setIsDisable(true)
  }

  const handleToSelectChangeValue = (e: any) => {
    // use in on blur
    if (typeof e === 'string') {
      // find in selected data
      let selectedValue = [...numberPaste]
      if (Array.isArray(selectedValue)) {
        const number = e
        // case 1 : number split by space
        let splitValues = number.split(' ')

        const filterCheck = splitValues.filter((el: any) => el.length < 9)
        if (filterCheck.length > 0) {
          let tmpSplitNumber = []
          let tmpCheck = ''

          for (let indexCheck = 0; indexCheck < splitValues.length; indexCheck++) {
            tmpCheck += splitValues[indexCheck]
            tmpCheck = tmpCheck.replace(/^0+/, '')
            if (tmpCheck.length >= 9) {
              tmpSplitNumber.push(tmpCheck)
              tmpCheck = ''
            }
          }

          splitValues = tmpSplitNumber
        }

        if (splitValues.length > 0 && splitValues[0].includes(',')) {
          // case 2 : try split number split by coma
          splitValues = number.split(',')
        }

        if (splitValues.length > 0) {
          // convert numbers
          const validatedNumbers = validateArrayPhonesRegion(splitValues, userRegion)
          const mapValidatedNumbers = validatedNumbers.map((it) => ({value: it, label: it}))
          setNumberPaste(mapValidatedNumbers)
          return
        } else {
          if (!isMobileValidate(number) || selectedValue.length > 50) {
            return
          }

          if (selectedValue.length === 0) {
            selectedValue = [
              {
                label: number,
                value: number,
              },
            ]
          } else {
            // find number
            let foundNumber = selectedValue.find((el) => el.value === number)
            if (!foundNumber) {
              selectedValue.push({
                label: number,
                value: number,
              })
            }
          }

          setNumberPaste(selectedValue)
        }

        return
      } else {
        if (isMobileValidate(e)) {
          setNumberPaste([{label: e, value: e}])
          return
        }
      }
    }

    if (Array.isArray(e) && e.length > 0) {
      const numbers = e.flatMap((it) => it?.value)
      
      // case 1 : number split by space
      let splitedBySpace = numbers.flatMap(it => it.split(' '))
      let numberArray: any[] = splitedBySpace

      const filterCheck = splitedBySpace.filter((el: any) => el.length < 9)
      if (filterCheck.length > 0) {
        let tmpSplitNumber = []
        let tmpCheck = ''

        for (let indexCheck = 0; indexCheck < splitedBySpace.length; indexCheck++) {
          tmpCheck += splitedBySpace[indexCheck]
          tmpCheck = tmpCheck.replace(/^0+/, '')
          if (tmpCheck.length >= 9) {
            tmpSplitNumber.push(tmpCheck)
            tmpCheck = ''
          }
        }

        numberArray = tmpSplitNumber
      }

      if (numberArray.length > 0 && numberArray.at(0).includes(',')) {
        // case 2 : try split number split by coma
        numberArray = numbers.flatMap(it => it.split(','))
      }
      
      const validatedNumbers = validateArrayPhonesRegion(numberArray, userRegion)
      setNumberPaste(validatedNumbers.map((it) => ({value: it, label: it})))
    }

    if (e?.length <= 0) {
      setNumberPaste([])
    }
  }

  useEffect(() => {
    if (copyPast === 'number') {
      if (numberPaste.length > 0) {
        setIsDisable(false)
      } else {
        setIsDisable(true)
      }
    }
  }, [copyPast, numberPaste])

  return (
    <>
      <div className='copy-paste'>
        <div className='form-check form-check-custom form-check-sm form-check-solid ms-4 mt-3'>
          <div className='row w-100'>
            <div className='row'>
              <input
                className='form-check-input col-2'
                type='radio'
                id='number'
                value=''
                checked={copyPast == 'number'}
                onChange={() => {
                  setNumberPaste([])
                  setCustomData('')
                  setIsDisable(true)
                  setCopyPast('number')
                }}
              />
              <label
                className='form-check-label align-items-start flex-column d-flex ms-0 col-8'
                htmlFor='number'
              >
                <span className='card-label fs-5'>Number Only</span>
              </label>
              {copyPast == 'number' && (
                <label className='form-check-label align-items-end flex-column d-flex ms-0 col-3'>
                  <span className='text-muted small' data-testid='txtNumbers'>{numberPaste.length} numbers</span>
                </label>
              )}
            </div>
            {copyPast === 'number' && (
              <CreatableSelect
                isMulti
                styles={{
                  dropdownIndicator: (provided, state) => ({
                    ...provided,
                    display: 'none', // Hide the dropdown indicator
                  }),
                  container: (provided, state) => ({
                    ...provided,
                    maxWidth: '92% !important',
                  }),
                  control: (provided, state) => ({
                    ...provided,
                    paddingTop: 10,
                    alignItems: 'start',
                    minHeight: 100,
                  }),
                }}
                className='ms-0 ps-0 me-0 pe-0 w-100'
                placeholder='input phone number'
                classNamePrefix='create-select'
                value={numberPaste}
                escapeClearsValue={false}
                formatCreateLabel={(value) => {
                  if (isNumberOnly(value.replaceAll(' ', ''))) {
                    return `Create  ${value}`
                  }
                  return null
                }}
                onBlur={(e) => handleToSelectChangeValue(e.currentTarget.value)}
                onChange={(e) => handleToSelectChangeValue(e)}
              />
            )}
          </div>
        </div>

        <div className='form-check form-check-custom form-check-sm form-check-solid ms-4 mt-3'>
          <div className='row w-100'>
            <input
              className='form-check-input col-2'
              type='radio'
              id='custom'
              value=''
              checked={copyPast == ''}
              onChange={() => {
                setNumberPaste([])
                setCustomData('')
                setIsDisable(true)
                setCopyPast('')
              }}
            />
            <label
              className='form-check-label align-items-start flex-column d-flex ms-0 col-8'
              htmlFor='custom'
            >
              <span className='card-label fs-5'>Custom details</span>
            </label>
            {copyPast == '' && (
              <>
                <textarea
                  onChange={(e: any) => {
                    setIsDisable(false)
                    setCustomData(e.target.value)
                  }}
                  value={customData}
                  className='form-control form-control-lg form-control-solid'
                  rows={5}
                  placeholder='Eg: Number, First Name, Last Name, Gender, Postal Code, Date of Birth, Special Field, Custom Field1, Custom Field2, Custom Field3'
                ></textarea>
                <span className='text-danger mt-3 gray-muted'>
                  Ensure each contact falls on separate lines, with the following format: Number,
                  First Name, Last Name, Gender, Postal Code, Date of Birth, Custom Field 1
                </span>
              </>
            )}
          </div>
        </div>
        <button className='btn btn-primary mt-5' disabled={isDisable} onClick={UploadData} data-testid="btnSubmitContacts">
          Submit
        </button>
      </div>
    </>
  )
}

export default UploadContactByCopyPast
